<template>
    <div class="row m-0">
      <div class="col-12">
        <div class="row">
            <div class="col-2 text-center d-none ">
                <div class="images"><img src="../assets/min-crm-avatar.jpg" class="rounded-circle" width="100%" style="padding-top: 5px; padding-bottom: 5px;"> 
                </div>
                <div class="ad f-16" v-if="user!=undefined">{{user.name}} {{user.surName}}</div>
                <div class="firma f-13 d-none">Hermes</div>
                <button type="button" class="btn SettingsBtn" >
                      {{$ml.get('PROFILE_SETTINGS')}}
                 </button>
            </div>
            <div class="col-12 col-sm-7 pl-0">
                <div class="col-12 contactsArea h-100 pb-2">
                    <div class="row">
                        <div class="col-12 bg-new-light hpx-50 d-flex align-items-center">
                            <p class="mb-0 f-16 light-darkGray-color">{{$ml.get('MY_PERSONS')}}</p>
                        </div>
                    </div>
                    <div class="row m-0 mt-3">
                        <div class="col-md-7 box-shadow d-flex align-items-center py-3 color-gray">
                            <i class="fa fa-users f-24 "></i>
                            <p class="mb-0 ml-3 totalCount">{{$ml.get('IS_BUY_TOTAL_ACCOUNT')}}</p>
                            <div class="f-28 color-black pl-3 totalCount">{{totalCount}}</div>
                        </div>
                    </div>

                    <div class="row m-0 mt-3">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-6 pl-0 pr-1">
                                    <div class="box-shadow text-center py-3 color-gray w-100">
                                        <i class="fa fa-users f-24 text-success"></i>
                                        <p class="mb-0 text-success mt-2">{{$ml.get('PERSON_ACCOUNT_USED')}}</p>
                                        <div class="f-28 color-black">{{account}}</div>
                                    </div>
                                </div>
                                <div class="col-6 pr-0 pl-1">
                                    <div class="box-shadow text-center py-3 color-gray">
                                        <i class="fa fa-users f-24 text-danger"></i>
                                        <p class="mb-0 text-danger mt-2">{{$ml.get('UNUSED_PERSON_ACCOUNT')}}</p>
                                        <div class="f-28 color-black">{{users.length-account}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 pr-0">
                            <button type="button" class="btn bg-new-primary f-14 w-100 text-left" data-toggle="modal" data-target="#addUser"  >
                                <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_USER')}}
                            </button>  

                            <button type="button" class="btn mcBgDark text-white mt-3 f-14 w-100 text-left" @click="exportUsersF()" >
                                <i class="fa fa-list-ul f-14 mr-2"></i> {{$ml.get('EXPORT_USERS')}}
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-5 planedArea pb-2 dNoneMobile">
                <div class="row">
                    <div class="col-12 bg-new-light hpx-50 d-flex align-items-center">
                        <p class="mb-0 f-16 light-darkGray-color">{{$ml.get('MY_PLANS')}}</p>
                    </div>
                </div>
                <div class="col-12 py-2 " v-for="contract in contracts" >
                    <div class="row mt-1">
                        <div class="col-12 f-14 color-gray text-center py-3" style="backgroundColor:#EBF8ED;">
                            <span class="font-weight-bold " style="color:#00620D">{{$ml.get('FREE_FOR_UP_100_USERS')}}</span>
                            <!-- <span class="color-black d-block float-right">{{contract.contractType | contractType($ml)}}</span> -->
                        </div>
                    </div>
                    <div class="row  mt-2 d-flex">
                        <div class="col-12 pl-0 pr-1 ">
                            <div class="text-center d-flex justify-content-center align-items-center flex-column py-3 w-100 p-1 f-14 h-100" style="box-shadow:0px 3px 5px 0px #b0bac599;">
                                <div class="pb-2 color-gray" style="width:40%" > {{$ml.get('ACCOUNT_STARTING_DATE')}}</div>
                          
                                <div class="f-15 ">{{formatDate(contract.beginDate.$date, "DD.MM.YYYY")}}</div>
                            </div>
                        </div>
                        
                        <!-- <div class="col-4 pr-0 pl-1">
                            <div class="box-shadow text-center py-3 color-gray p-2 f-16 h-100">
                                {{$ml.get('RENEW_DATE')}}<br/>
                            <span class="f-15">{{formatDate(contract.renewDate.$date, "DD/MM/YYYY")}}</span>
                            </div>
                        </div> -->
                        
                        <!-- <div class="col-4 pr-0 pl-1">
                            <div class="box-shadow text-center py-3 color-gray p-1 f-14 h-100">
                                {{$ml.get('ACCOUNT_EXPIRATION_DATE')}}<br/>
                            <span class="f-15" v-if="contract.endDate!=undefined">{{formatDate(contract.endDate.$date, "DD/MM/YYYY")}}</span>
                            </div>
                        </div> -->
                    </div>
                    <div class="row mt-2" v-if="contract.x">
                        <div class="col-12"> 
                            <div class="float-left text-danger cursor-pointer" @click="cancelContract(contract._id.$oid)"><i class="fa fa-trash-o h-14 mr-1"></i>{{$ml.get('DELETE')}}</div>
                            <div class="float-right  text-success cursor-pointer" @click="updateContract(contract)" data-toggle="modal" data-target="#buymodal"><i class="fa fa-pencil-square h-14 mr-1"></i>{{$ml.get('UPDATE')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      
      <div class="col-12 usersedit">
        <div class="row mt-4" id="usersArea">
            <div class="col-md-4">
                <div class="sticky-top">
                    <div class="row"  >
                        <div class="col-12 bg-new-light hpx-50 align-items-center d-flex justify-content-between typeTitle">
                            <h3 class="font-family-bold text-white f-14 m-0 f-Up light-gray-color">{{$ml.get('MANAGER')}}</h3>
                            <button class="btn btn-new border-0 bg-transparent" id="settings" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-cog  btn-click"></i>
                            </button>
                            <div class="dropdown-menu permission-dd dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="settings" >
                                <div class="mcBgDark text-white p-3">
                                    {{$ml.get('MANAGER_PERMISSIONS')}}
                                </div>
                                <div class="scrollDiv">
                                    <div class="w-100" v-for="(i,index) in permissionList">
                                        <label class="custom-checkbox">
                                            <input type="checkbox"  v-model="adminArray" id="1"  :value="i" name="admin"> <span class="label-text f-14">{{translatePermission(i, $ml)}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 dealBtnStyle my-2 float-left">
                                    <button class="btn btn-lg btn-primary ml-3 float-right h-32"  @click="updatePermissionSet('1')">{{$ml.get('SAVE')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row border-line-80 border-top-0 border-left-0 border-bottom-0 bgGrey h-100">
                    <div class="col-12">
                        <div class="row p-1">
                            <div class="col-12 p-0"> 
                                  <draggable :options="{group:'people',animation: 300}" class="userList p-0" id="1" style="min-height: 700px;" @start="dragStart" @end="dragEnd">
                                      <template v-for="u in users" :key="u && u._id && u._id.$oid">
                                      <div v-if="u && u.userRoleId === 1" class="d-inline-block w-100 border-line-80 mb-2 boxHoverStyle bg-white btn-click" :id="u._id && u._id.$oid">
                                          <div class="col-12 p-2">
                                              <label class="v-center f-14 font-family-regular col-9 col-xl-10 float-left btn-click">{{u.name}} {{u.surName}}</label>
                                              <div class="col-3 col-xl-2 float-left p-1">
                                                  <label class="switch">
                                                    <input type="checkbox" v-model="u.x" @change="checkactive(u._id.$oid,u.x)" >
                                                    <span class="slider round" :class="{true:u.x}"></span>
                                                  </label>
                                              </div>
                                          </div>
                                      </div>
                                      </template>
                                  </draggable>
                            </div>
                        </div>                             
                    </div>
                </div>                     
            </div>
            <div class="col-md-4">
                <div class="sticky-top">
                    <div class="row" >
                        <div class="col-12 bg-new-light hpx-50 align-items-center d-flex justify-content-between typeTitle">
                            <h3 class="font-family-bold text-white f-14 m-0 f-Up light-gray-color">{{$ml.get('AUTHORIZED')}}</h3>
                            <button class="btn btn-new border-0 bg-transparent" id="settings" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-cog btn-click"></i>
                            </button>
                            <div class="dropdown-menu permission-dd dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="settings" >
                                <div class="mcBgDark text-white p-3">
                                    {{$ml.get('AUTHORIZED_PERMISSIONS')}}
                                </div>
                                <div class="scrollDiv">
                                    <div class="w-100" v-for="(i,index) in permissionList">
                                        <label class="custom-checkbox">
                                            <input type="checkbox"  v-model="managerArray" id="3" :value="i" name="manager"> <span class="label-text f-14">{{translatePermission(i, $ml)}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 dealBtnStyle my-2 float-left">
                                    <button class="btn btn-lg btn-primary ml-3 float-right h-32"  @click="updatePermissionSet('3')">{{$ml.get('SAVE')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row border-line-80 border-top-0 border-left-0 border-bottom-0 h-100 mcBgDarkGrey">
                    <div class="col-12">
                        <div class="row p-1">
                            <div class="col-12 p-0"> 
                                  <draggable :options="{group:'people',animation: 300}" class="userList p-0" id="3" style="min-height: 700px;" @start="dragStart" @end="dragEnd">
                                      <template v-for="u in users" :key="u && u._id && u._id.$oid">
                                      <div v-if="u && u.userRoleId === 3" class="d-inline-block w-100 border-line-80 mb-2 boxHoverStyle bg-white btn-click" :id="u._id && u._id.$oid">
                                          <div class="col-12 p-2">
                                              <label class="v-center f-14 font-family-regular col-9 col-xl-10 float-left btn-click">{{u.name}} {{u.surName}}</label>
                                              <div class="col-3 col-xl-2 float-left p-1">
                                                  <label class="switch">
                                                    <input type="checkbox" v-model="u.x" @change="checkactive(u._id.$oid,u.x)" >
                                                    <span class="slider round" :class="{true:u.x}"></span>
                                                  </label>
                                              </div>
                                          </div>
                                      </div>
                                      </template>
                                  </draggable>
                            </div>
                        </div>                             
                    </div>
                </div>                     
            </div>
            <div class="col-md-4">
                <div class="sticky-top">
                    <div class="row" >
                        <div class="col-12 bg-new-light hpx-50 align-items-center d-flex justify-content-between typeTitle">
                            <h3 class="font-family-bold text-white f-14 m-0 f-Up light-gray-color">{{$ml.get('USER')}}</h3>
                            <button class="btn btn-new border-0 bg-transparent" id="settings" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-cog btn-click"></i>
                            </button>
                            <div class="dropdown-menu dropdown permission-dd dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="settings" >
                                <div class="mcBgDark text-white p-3">
                                    {{$ml.get('USER_PERMISSIONS')}}
                                </div>
                                <div class="scrollDiv">
                                    <div class="w-100" v-for="(i,index) in permissionList">
                                        <label class="custom-checkbox">
                                            <input type="checkbox"  v-model="userArray" id="2" :value="i" name="user"> <span class="label-text f-14">{{translatePermission(i, $ml)}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 dealBtnStyle my-2 float-left">
                                    <button class="btn btn-lg btn-primary ml-3 float-right h-32"  @click="updatePermissionSet('2')">{{$ml.get('SAVE')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row border-line-80 border-top-0 border-left-0 border-right-0 border-bottom-0 bgGrey h-100">
                    <div class="col-12">
                        <div class="row p-1">
                            <div class="col-12 p-0"> 
                                <draggable :options="{group:'people',animation: 300}" class="userList p-0" id="2" style="min-height: 700px;" @start="dragStart" @end="dragEnd">
                                    <template v-for="u in users" :key="u && u._id && u._id.$oid">
                                    <div v-if="u && u.userRoleId === 2" class="d-inline-block w-100 border-line-80 mb-2 boxHoverStyle bg-white btn-click" :id="u._id && u._id.$oid">
                                        <div class="col-12 p-2">
                                            <label class="v-center f-14 font-family-regular col-9 col-xl-10 float-left btn-click">{{u.name}} {{u.surName}}</label>
                                            <div class="col-3 col-xl-2 float-left p-1">
                                                <label class="switch">
                                                    <input type="checkbox" v-model="u.x" @change="checkactive(u._id.$oid,u.x)" >
                                                    <span class="slider round" :class="{true:u.x}"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    </template>
                                </draggable>
                            </div>
                        </div>                             
                    </div>
                </div>                     
            </div>
        </div>
        <div class="modal fade" id="addUser" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:600px!important">
                <div class="modal-content bgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{$ml.get('ADD_USER')}}</h5>
                        <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="activityGroupButton col-12 p-0"  role="group" aria-label="activityGroupButton">
                            <button type="button" :class="{active:saveRoleId == 1}" @click="saveRoleId=1" class="btn f-14 font-family-bold f-w-normal">{{$ml.get('MANAGER')}}</button>
                            <button type="button" :class="{active:saveRoleId == 3}" @click="saveRoleId=3" class="btn f-14 font-family-bold f-w-normal">{{$ml.get('AUTHORIZED')}}</button>
                            <button type="button" :class="{active:saveRoleId == 2}" @click="saveRoleId=2" class="btn f-14 font-family-bold f-w-normal">{{$ml.get('USER')}}</button>
                        </div>
                        <div class="row">
                          <div class="col-12 ">
                            <label class="new-label">{{$ml.get('NAME')}}*</label>
                            <input type="text" v-model="name" class="new-input" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label class="new-label">{{$ml.get('SURNAME')}} *</label>
                            <input type="text" v-model="surName" class="new-input" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label class="new-label">{{$ml.get('E_MAIL')}} *</label>
                            <input type="text" v-model="email" class="new-input" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label class="new-label">{{$ml.get('PHONE')}}</label>
                            <input type="text" v-model="phone" class="new-input" />
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                      <button type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                      <button type="button" class="btn-new save" @click="saveUser">{{$ml.get('SAVE')}}</button>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <orderPayment ref="orderPayment" :user="user" :users="users" @cancelPayment="cancelPayment" @getUsers="$emit('getUsers')" :contracts="contracts" :accountCount="account" :newPacketBeginDate="newPacketBeginDate" :newPacketEndDate="newPacketEndDate" />
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
  
  <script>
  import Vue from 'vue'
  import draggable from 'vuedraggable'
  import orderPayment from '@/components/orderPayment'
  import axios from 'axios'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
  import {mapState} from 'vuex'
  import {mapActions} from 'vuex'
  import _ from 'underscore'
  import defineAbilityFor from '../services/rules'
  export default {
      data () {
          return {
              roleId:"",
              userId:"",
              saveRoleId:2,
              setRoleId:1,
              adminArray:[],
              managerArray:[],
              userArray:[],
              email:"",
              name:"",
              surName:"",
              phone:"",
              oldStageId:"",
              contracts:[],
              totalCount:1,
              account:1,
              newPacketBeginDate:"",
              newPacketEndDate:"",
              userValue:this.user

          }
      },
      components:{
          draggable,
          orderPayment
      },
      computed:{
          ...mapState([
              'permissionList',
              'baseUrl'
          ])
      },
      props:["user","users"],
      methods:{
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        translatePermission: function(value, ml) {
            const mlInst = ml || this.$ml;
            let permissions = []
            permissions["can_delete_deals"] = mlInst.get('CAN_DELETE_DEALS')
            permissions["can_bulk_delete_deals"] = mlInst.get('CAN_BULK_DELETE_DEALS')
            permissions["can_bulk_update_deals"] = mlInst.get('CAN_BULK_UPDATE_DEALS')
            permissions["can_reopen_closed_deals"] = mlInst.get('CAN_REOPEN_CLOSED_DEALS')
            permissions["can_see_other_users_deals_report"] = mlInst.get('CAN_SEE_OTHER_USERS_DEALS_REPORTS')
            permissions["can_see_other_users_activities_report"] = mlInst.get('CAN_SEE_OTHER_USERS_ACTIVITY_REPORTS')
            permissions["can_use_advanced_search"] = mlInst.get('CAN_USE_ADVANCED_SEARCH')
            permissions["can_change_owner_of_items"] = mlInst.get('CAN_CHANGE_OWNER_OF_ITEMS')
            permissions["can_delete_activities"] = mlInst.get('CAN_DELETE_ACTIVITIES')
            permissions["can_bulk_delete_activities"] = mlInst.get('CAN_BULK_DELETE_ACTIVITIES')
            permissions["can_delete_organizations"] = mlInst.get('CAN_DELETE_COMPANIES')
            permissions["can_bulk_delete_organizations"] = mlInst.get('CAN_BULK_DELETE_COMPANIES')
            permissions["can_delete_contacts"] = mlInst.get('CAN_DELETE_CONTACTS')
            permissions["can_bulk_delete_contacts"] = mlInst.get('CAN_BULK_DELETE_CONTACTS')
            permissions["can_add_products"] = mlInst.get('CAN_ADD_PRODUCTS')
            permissions["can_edit_products"] = mlInst.get('CAN_EDIT_PRODUCTS')
            permissions["can_delete_products"] = mlInst.get('CAN_DELETE_PRODUCTS')
            permissions["can_bulk_delete_products"] = mlInst.get('CAN_BULK_DELETE_PRODUCTS')
            permissions["can_export_data_from_lists"] = mlInst.get('CAN_EXPORT_DATA')
            permissions["can_use_import"] = mlInst.get('CAN_IMPORT_DATA')
            permissions["can_see_other_users_deals"] = mlInst.get('CAN_SEE_OTHER_USERS_DEALS')
            permissions["can_see_other_users_activities"] = mlInst.get('CAN_SEE_OTHER_USERS_ACTIVITIES')
            permissions["can_see_other_users_organizations"] = mlInst.get('CAN_SEE_OTHER_USERS_COMPANIES')
            permissions["can_see_other_users_contacts"] = mlInst.get('CAN_SEE_OTHER_USERS_CONTACTS')
            permissions["can_see_other_users_products"] = mlInst.get('CAN_SEE_OTHER_USERS_PRODUCTS')
            permissions["can_edit_other_users_deals"] = mlInst.get('CAN_EDIT_OTHER_USERS_DEALS')
            permissions["can_edit_other_users_activities"] = mlInst.get('CAN_EDIT_OTHER_USERS_ACTIVITIES')
            permissions["can_edit_other_users_organizations"] = mlInst.get('CAN_EDIT_OTHER_USERS_COMPANIES')
            permissions["can_edit_other_users_contacts"] = mlInst.get('CAN_EDIT_OTHER_USERS_CONTACTS')
            permissions["can_edit_other_users_products"] = mlInst.get('CAN_EDIT_OTHER_USERS_PRODUCTS')
            permissions["can_delete_other_users_deals"] = mlInst.get('CAN_DELETE_OTHER_USERS_DEALS')
            permissions["can_delete_other_users_activities"] = mlInst.get('CAN_DELETE_OTHER_USERS_ACTIVITIES')
            permissions["can_delete_other_users_organizations"] = mlInst.get('CAN_DELETE_OTHER_USERS_COMPANIES')
            permissions["can_delete_other_users_contacts"] = mlInst.get('CAN_DELETE_OTHER_USERS_CONTACTS')
            permissions["can_delete_other_users_products"] = mlInst.get('CAN_DELETE_OTHER_USERS_PRODUCTS')
            permissions["can_export_search_output"] = mlInst.get('CAN_EXPORT_SEARCH_OUTPUT')
            permissions["can_update_notes"] = mlInst.get('CAN_UPDATE_NOTES')
            permissions["can_delete_notes"] = mlInst.get('CAN_DELETE_NOTES')
            permissions["can_add_cloud_api_token"] = mlInst.get('CAN_ADD_CLOUD_API_TOKEN')
            permissions["can_open_process"] = mlInst.get('CAN_OPEN_PROCESS')
            permissions["can_add_calendar"] = mlInst.get('CAN_ADD_CALENDAR')
            return permissions[value] || value
        },
        translate: function(value, ml) {
            return this.translatePermission(value, ml);
        },
        contractType: function(value, ml) {
            const mlInst = ml || this.$ml;
            let val = ""
            if (value == "annual") {
                return mlInst.get('ANNUAL')
            } else {
                val = mlInst.get('MONTHLY')
            }
            return val
        },
        cancelPayment(){
            this.newPacketBeginDate=this.$moment(new Date()).add(1, 'days').format("DD/MM/YYYY")
            this.newPacketEndDate=this.$moment(new Date()).add(1, 'days').add(1,'years').format("DD/MM/YYYY")
            this.$refs.orderPayment.setAccountCount=this.account
            if(this.contracts.find(c=>c.x==true)!=undefined){
                this.totalCount=this.contracts.find(c=>c.x==true).totalSeat
                this.account=this.contracts.find(c=>c.x==true).usedSeat
            }else{
                this.totalCount=this.users.length
                this.account=this.users.filter(usr => usr.x==true).length
            }
          },
          updateContract(contract){
            this.$refs.orderPayment.contractId=contract._id['$oid']
            this.$refs.orderPayment.updatePayment=true
            this.$refs.orderPayment.renewDate=contract.renewDate.$date
            this.$refs.orderPayment.newPacketName=contract.contractType
            this.$refs.orderPayment.setAccountCount=contract.totalSeat
            this.$refs.orderPayment.oldSetAccountCount=contract.totalSeat

            this.newPacketBeginDate = this.$moment(contract.beginDate.$date).format("DD/MM/YYYY")
            if(contract.endDate!=undefined){
                this.newPacketEndDate = this.$moment(contract.endDate.$date).format("DD/MM/YYYY")
            }else{
                this.newPacketEndDate="-"
            }

          },
          cancelContract(contractId){
            Swal.fire({
                title: "Plan sil",
                text: "Planınızı silmek istediğinizden emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('YES'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            })
            .then((result) => {
                if (result.isConfirmed) {

                     
                    axios({
                    method:'POST',
                    url:'/cancelContract',
                    baseURL: this.baseUrl,
                    data: {
                        contractId:contractId
                    },
                    withCredentials:true
                    }).then((res)=>{
                        if(res.data.status.code==0){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.data.status.desc 
                            })
                             
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: res.data.status.desc 
                            })
                             
                        }
                    })
                }
            })
          },
          exportUsersF(){
              this.exportUsers()
          },
          checkactive(id,status){
              if(status){
                  status="active"
              }else{
                  status="passive"
              }
               
              axios({
              method:'POST',
              url:'/changeUserStatus',
              baseURL: this.baseUrl,
              data: {
                  userId:id,
                  status:status
              },
              withCredentials:true
              }).then((res)=>{
                  if(res.data.status.code==0){
                      this.$emit("getUsers")
                      this.$notify({ 
                          group: 'foo',
                          type: 'success', 
                           title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc 
                      })
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                           title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                      this.users.find(user=>user._id.$oid==id).x=false
                       
                  }
              })
          },
          dragStart(event){
              this.oldStageId=event.to.id
          },
          dragEnd(event){
              this.userId=event.item.id
              this.roleId=parseInt(event.to.id)
              if(parseInt(this.oldStageId)===this.roleId){
                  return false
              }
               
              axios({
              method:'POST',
              url:'/updateUserRole',
              baseURL: this.baseUrl,
              data: {
                  userId:this.userId,
                  roleId:this.roleId
              },
              withCredentials:true
              }).then((res)=>{
                  if(!res.data.status){
                  //this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                  //this.user=res.data.content.users
                      this.$notify({ 
                          group: 'foo',
                          type: 'success', 
                           title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc 
                      })
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                           title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                       
                  }
              })
          },
          getUsers(){
               
              axios({
                  method:'POST',
                  url:'/getUsers',
                  baseURL: this.baseUrl,
                  data: {
                  },
                  withCredentials:true
              }).then((res)=>{
                  if(!res.data.status){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.userValue=res.data.content.users
                       
                  }else{
                       
                  }
              })
          },
          getContracts(){
               
              axios({
                  method:'POST',
                  url:'/getContracts',
                  baseURL: this.baseUrl,
                  data: {
                  },
                  withCredentials:true
              }).then((res)=>{
                  if(!res.data.status){
                  this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.contracts=res.data.content.contracts
                      if(this.contracts.find(c=>c.x==true)!=undefined){
                        this.totalCount=this.contracts.find(c=>c.x==true).totalSeat
                        this.$refs.orderPayment.setAccountCount=this.contracts.find(c=>c.x==true).usedSeat
                        this.account=this.contracts.find(c=>c.x==true).usedSeat
                      }else{
                        this.totalCount=this.users.length
                        this.account=this.users.filter(usr => usr.x==true).length
                        this.$refs.orderPayment.setAccountCount=this.users.filter(usr => usr.x==true).length
                      }
                      
                      this.newPacketBeginDate=this.$moment(new Date()).add(1, 'days').format("DD/MM/YYYY")
                      this.newPacketEndDate=this.$moment(new Date()).add(1, 'days').add(1,'years').format("DD/MM/YYYY")
                       
                  }else{
                       
                  }
              })
          },
          
          getPermissionSets(){
               
              axios({
                  method:'POST',
                  url:'/getPermissionSets',
                  baseURL: this.baseUrl,
                  data: {
                  },
                  withCredentials:true
              }).then((res)=>{
                  if(res.data.status===false){
                      this.$router.push('/logout')
                  }
                  
                    res.data.content.permissionSets.forEach(item => {
                        // console.log(item.roleId)
                        if(item.roleId === 1){
                            this.adminArray = _.intersection(item.permissions,this.permissionList)
                        }
                        else if(item.roleId === 2){
                            this.userArray= _.intersection(item.permissions,this.permissionList)
                        }
                        else if(item.roleId === 3){
                            this.managerArray  = _.intersection(item.permissions,this.permissionList)
                        }
                    })
                
                     
              })
          },
          getPermissionSetF(userRoleId){
          axios({
                  method:'POST',
                  url:'/getPermissionSet',
                  data:{
                    roleId:userRoleId
                  },
                  baseURL: this.baseUrl,
                    withCredentials:true
                  })
                  .then((res)=>{
                    return res
                  })
                  .then((res)=>{
                    if(res.data.status.code==0){
                      localStorage.loginCookie=true;
                      this.setRules()   
                    }else{
                       
                    }
                })
        },
        setRules(){
            try {
              axios({
                method:'GET',
                url:`/getUserPermissions`,
                baseURL: process.env.API_URL,
                withCredentials:true
              }).then((rez)=>{
                var permissions = []
                console.log("res of get user permissions")
                console.log(rez)
                permissions =  rez.data
                localStorage.setItem('rules',JSON.stringify(permissions))
                this.$ability.update(defineAbilityFor(permissions))
               
              })
            }catch (err) {
              // Handle Error Here
              console.error(err);
            }
        },
          updatePermissionSet(id){
                 
                var updatePermissionArray = []
                if(id==="1"){
                    updatePermissionArray=this.adminArray
                }else if(id==="2"){
                    updatePermissionArray=this.userArray
                }else if(id==="3"){
                    updatePermissionArray=this.managerArray
                }
                
                axios({
                    method:'POST',
                    url:'/updatePermissionSet',
                    baseURL: this.baseUrl,
                    data: {
                    roleId:id,
                    permissions:updatePermissionArray //(array olacak)
                    },
                    withCredentials:true
                }).then((res)=>{
                    if(res.data.status===false){
                        this.$router.push('/logout')
                    }
                    if(res.data.status.code==0){
                    //this.user=res.data.content.users
                         
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.data.status.details
                        })
                        // this.getPermissionSets()
                        // if("this.$can('can_add_cloud_api_token')"){
                        //     console.log("update ife girildi ata");
                        //     this.getPermissionSetF(localStorage.roleId)
                        // }   
                     this.getPermissionSetF(localStorage.roleId)
                    }else{
                         
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: res.data.status.details
                        })
                    }
                })
          },
          saveUser(){
              if(this.name.length===0){
                  this.$notify({ 
                      group: 'foo',
                      type: 'error', 
                      title: this.$ml.get('ERROR'),
                      text: this.$ml.get('NAME_CANNOT_BE_BLANK')
                  })
                  return false;
              }
              if(this.surName.length===0){
                  this.$notify({ 
                      group: 'foo',
                      type: 'error', 
                      title: this.$ml.get('ERROR'),
                      text: this.$ml.get('SURNAME_CANNOT_BE_EMPTY')
                  })
                  return false;
              }
              if(this.email.length===0){
                  this.$notify({ 
                      group: 'foo',
                      type: 'error', 
                      title: this.$ml.get('ERROR'),
                      text: this.$ml.get('EMAIL_CANNOT_EMPTY')
                  })
                  return false;
              }
              if(this.validEmail(this.email)===false){
                  return false;
              }
              
              axios({
                  method:'POST',
                  url:'/createStandardUser',
                  baseURL: this.baseUrl,
                  data: {
                      email:this.email,
                      name:this.name,
                      surName:this.surName,
                      userRoleId:this.saveRoleId
                  },
                  withCredentials:true
              }).then((res)=>{
                  if(res.data.status===false){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.email=""
                      this.name=""
                      this.surName=""
                      this.phone=""
                      this.getUsers()
                      $("#addUser").modal("hide")
                      //this.user=res.data.content.users
                      this.$notify({ 
                          group: 'foo',
                          type: 'success', 
                          title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc 
                      })
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                          title: 'Hata!',
                          text: res.data.status.desc 
                      })
                       
                  }
              })
          },
          validEmail: function (email) {
              var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if(email.length>0&&email!==undefined){
                  if(re.test(email)===false){
                      this.$notify({ group: 'foo',
                          type: 'warn', 
                          title: 'Email geçersiz!',
                          text: 'Lütfen geçerli email giriniz.' 
                      })
                      return false
                  }else{
                      return email
                  }
              }else{
                  return false
              }
          },
          ...mapActions([
              'updateLoading',
              'exportUsers'
          ]),
      },
      created() {
        this.getPermissionSets();
      },
      watch:{
          users(){
            this.getContracts();
          },
          userArray(){
            //   console.log(this.userArray);
          }
      },
  }
  
  $(document).ready(function(){
      $(this).on('click', '.dropMenu', function (e) {
          e.stopPropagation();
      });
  });
  </script>
<style scoped>
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
.dropdown-menu.permission-dd{
    margin-right: 15px !important;
    margin-top: 0;
}
.scrollDiv{
  overflow-y: scroll;
  height: 200px;
}
.icon-solid-ekle:before{
    color:white!important;
}
.nav button{
  background-color: white
}
ul.userList{
  min-height: 100vh;
}
.bgGrey{
    background-color: #f0f5fb !important; 
}

.nav button {
  width: 33%;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: white;
  border: 1px solid #3767a0;
}
.nav button.active{
  background-color: #3767a0;
  color: white;
}


.setUserPopup label{
  cursor: pointer;
  color: #666;
}

.SettingsBtn {
  background-color: transparent;
  border: 1px solid #000;
  border-radius: 15px;
  padding: 4px 8px;
  font-size: 13px;
  margin: 10px 0;
}
.SettingsBtn:hover {
  background-color: #3767a0;
  color: #FFF;
}
.SatinAlmaBilgi>div{
  margin: 15px 0;
}
.setUserPopup input[type="checkbox"], .setUserPopup input[type="radio"]{
  position: absolute;
  right: 9000px;
}

/*Check box*/
.setUserPopup input[type="checkbox"] + .label-text:before{
  content: "\f096";
  font-family: "FontAwesome";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing:antialiased;
  width: 1em;
  display: inline-block;
  margin-right: 5px;
}

.setUserPopup input[type="checkbox"]:checked + .label-text:before{
  content: "\f14a";
  color: #2980b9;
  animation: effect 250ms ease-in;
}

.setUserPopup input[type="checkbox"]:disabled + .label-text{
  color: #aaa;
}

.setUserPopup input[type="checkbox"]:disabled + .label-text:before{
  content: "\f0c8";
  color: #ccc;
}
@keyframes effect{
  0%{transform: scale(0);}
  25%{transform: scale(1.3);}
  75%{transform: scale(1.4);}
  100%{transform: scale(1);}
}


.planedArea, .contactsArea{
background: #FAFAFA;
border: 0.5px solid #AFC2D9;
border-radius: 4px;
overflow: hidden;
}


.activityGroupButton button {
    color: #6a6b75;
    background-color: transparent;
}

. button.active{
    background-color: #3767a0;
    color: white;
}
.typeTitle button{
    color: #92959a;
    font-size:20px;
}
.typeTitle.show button, .typeTitle button:hover{
    background-color: #3c89d8 !important;
    color: white;
}
.planedArea .passive {
    opacity: 0.5;
}

.switch input:checked + .slider.true{
    background-color: #1991eb;
}
.switch input:checked + .slider.true:before{
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
    background-color: #3767a050;
    border-radius: 20px;
}

.switch input:focus + .slider.true {
    box-shadow: 0 0 1px #3767a0;
}
.sticky-top{
    top: 60px;
    z-index: 995;
}
@media (max-width: 768px){
    .text-left{
        margin-left: -15px;
        margin-top: 16px;
        font-size: 14px !important;
        min-width: 150px;
    }
    .totalCount{
        font-size: 18px !important;
        padding: 0 !important;
        margin-left: 0.35em !important;
    }
    .userList{
        min-height: 100px !important;
overflow: hidden;
z-index: 0;

    }
    .sticky-top{
        z-index: 0;
    }
}
@media (max-width: 576px){
    .dNoneMobile{
        display: none;
    }
}

</style>
